import React, { useEffect, useState } from "react"
import { V3RangeInpt, V3RangeIptProgress, V3RangeIptWrapper } from "./V3RangeInput.styles";

const getVal = (val: string | number | readonly string[] | undefined) => {
    if (typeof val === "string") return parseFloat(val);
    if (typeof val === "number") return val;
    return 0;
}

interface V3RangeInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    barColor?: string;
    progressColor?: string;
    thumbSize?: number
}

export const V3RangeInput = ({
    value,
    max,
    defaultValue,
    onChange,
    barColor,
    thumbSize,
    progressColor,
    ...rest
}: V3RangeInputProps) => {

    const [progress, setProgress] = useState((value ? getVal(value) : 0) / getVal(max));

    useEffect(() => {
        const val = value || defaultValue || "0";
        setProgress(getVal(val) / getVal(max));
    }, [value, defaultValue, max]);

    return <V3RangeIptWrapper>
        <V3RangeInpt
            type="range"
            max={max}
            $barColor={barColor}
            $progressColor={progressColor}
            thumbSize={thumbSize}
            value={value}
            defaultValue={defaultValue}
            onChange={(e) => {
                setProgress(getVal(e.target.value) / getVal(max));
                onChange && onChange(e);
            }}
            {...rest}
        />
        <V3RangeIptProgress style={{ width: `${progress * 100}%` }} $progressColor={progressColor} />
    </V3RangeIptWrapper>
}